import { products, clouds } from "../../../../src/components/product.js";
import * as React from 'react';
export default {
  products,
  clouds,
  React
};